<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col sm="12" md="6">
                    <search-bar
                        v-model="query.search"
                        v-on:request-search="onRequestSearch"
                    />
                </v-col>
                <v-col sm="6" md="3">
                    <sort-bar
                        v-model="query.sort"
                        v-bind:items="sortItems"
                        v-on:request-sort="onRequestSort"
                    />
                </v-col>
                <v-col sm="6" md="3">
                    <filter-bar
                        label="Order Statuses"
                        v-model="query.order_statuses"
                        v-bind:items="statusFilterItems"
                        v-on:request-filter="onRequestStatusFilter"
                    />
                </v-col>
            </v-row>
        </v-container>
        <v-pagination
            v-model="pagination.currentPage"
            v-bind:length="pagination.pageCount"
            v-on:input="onRequestPageChange"
        />
        <p class="mt-2 text--secondary text-center text-subtitle-2">
            {{ pagination.pageItemFrom }} - {{ pagination.pageItemTo }} of
            {{ pagination.totalItems }}
        </p>
        <v-row justify="center">
            <v-col cols="12" md="8" lg="6">
                <order-list-item
                    class="mb-4"
                    v-for="item in orders"
                    v-bind:key="item.id"
                    v-bind:order="item"
                    v-on:request-show="showOrder"
                    v-on:request-edit="editOrder"
                    v-on:request-delete="deleteOrder"
                />
            </v-col>
        </v-row>
        <v-pagination
            v-model="pagination.currentPage"
            v-bind:length="pagination.pageCount"
            v-on:input="onRequestPageChange"
        />
    </div>
</template>

<script>
import store from '@/store/';
import snackbar from '@/utils/snackbar';
import orderApi from '@/api/orderApi';
import restaurantApi from '@/api/restaurantApi';

export default {
    components: {
        'order-list-item': () => import('@/views/rest/OrderListItem.vue'),
        'search-bar': () => import('@/components/SearchBar.vue'),
        'sort-bar': () => import('@/components/SortBar.vue'),
        'filter-bar': () => import('@/components/FilterBar.vue')
    },
    data() {
        return {
            orders: [],
            query: {
                search: '',
                sort: '',
                order_statuses: []
            },
            pagination: {
                currentPage: 1,
                pageItemFrom: 0,
                pageItemTo: 0,
                totalItems: 0,
                pageCount: 0
            },
            sortItems: [
                { text: 'Newest first', value: 'created_at:desc' },
                { text: 'Oldest first', value: 'created_at:asc' }
            ],
            statusFilterItems: [
                { text: 'New orders', value: 'new' },
                { text: 'Assigned orders', value: 'assigned' },
                { text: 'In-progress orders', value: 'in-progress' },
                { text: 'Completed orders', value: 'completed' },
                { text: 'Cancelled orders', value: 'cancelled' }
            ]
        };
    },
    async beforeRouteEnter(to, from, next) {
        const restaurantId = store.state.auth.user.restaurant.id;
        const response = await restaurantApi.getRestaurantOrders(
            restaurantId,
            to.query
        );
        next(vm => vm.setData(response.data.orders, { ...to.query }));
    },
    async beforeRouteUpdate(to, from, next) {
        const restaurantId = store.state.auth.user.restaurant.id;
        const response = await restaurantApi.getRestaurantOrders(
            restaurantId,
            to.query
        );
        this.setData(response.data.orders, { ...to.query });
        next();
    },
    methods: {
        showOrder(order) {
            this.$router.push({
                name: 'rest-order-show',
                params: {
                    order_id: order.id
                }
            });
        },
        editOrder(order) {
            this.$router.push({
                name: 'rest-order-edit',
                params: {
                    order_id: order.id
                }
            });
        },
        async deleteOrder(order) {
            const confirmed = confirm('Confirm deletion');
            if (!confirmed) return;
            await orderApi.deleteOrder(order.id);
            // Avoid reloading the page. Note that router.go() reloads
            this.onRequestPageChange(this.pagination.currentPage);
            snackbar.show('Deleted successfully', 'success');
        },
        // Expecting paginated to be response.data.orders
        setData(paginated, query) {
            this.query = query;
            this.orders = paginated.data;
            this.pagination.totalItems = paginated.total;
            this.pagination.currentPage = paginated.current_page;
            this.pagination.pageItemFrom = paginated.from;
            this.pagination.pageItemTo = paginated.to;
            this.pagination.pageCount = paginated.last_page;
        },
        async onRequestSearch() {
            // Don't use page on new search
            const params = { search: this.query.search };
            await this.request(params);
            this.query.sort = null; // Reset sort
            this.query.order_statuses = []; // Reset status orders
        },
        async onRequestSort() {
            // Don't use page on new sort
            await this.request(this.query);
        },
        async onRequestStatusFilter() {
            // Don't use page on new filter
            await this.request(this.query);
        },
        async onRequestPageChange(newPage) {
            const params = {
                ...this.query,
                page: newPage
            };
            await this.request(params);
        },
        async request(params) {
            this.orders = [];
            this.$router.push({ query: params });
        }
    }
};
</script>
